module.exports = __webpack_public_path__ + "img/image01.73d000a5.jpg";